import * as React from 'react';

export function useIsOverflowing<T extends HTMLElement>() {
  const ref = React.useRef<T>(null);
  const [overflowing, setOverflowing] = React.useState(false);

  React.useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const checkOverflow = () => {
      if (!el || el.scrollWidth === 0 || el.clientWidth === 0) return;

      const isOverflowing = el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
      setOverflowing(isOverflowing);
    };

    // Check immediately
    checkOverflow();

    const ro = new ResizeObserver(checkOverflow);
    ro.observe(el);

    return () => ro.disconnect();
  }, []);

  return { ref, overflowing };
}
